/* Two Brothers Grooming — product page interactions (vanilla JS, no libraries) */
(function () {
  if (window.__olInit) return;
  window.__olInit = true;

  document.addEventListener('click', function (e) {
    /* ---- Gallery thumbnails ---- */
    var thumb = e.target.closest('[data-ol-thumb]');
    if (thumb) {
      var gal = thumb.closest('[data-ol-gallery]');
      var main = gal && gal.querySelector('[data-ol-main]');
      if (main) main.src = thumb.getAttribute('data-img');
      gal.querySelectorAll('[data-ol-thumb]').forEach(function (t) { t.classList.toggle('on', t === thumb); });
      return;
    }

    /* ---- Pack selector (variant) ---- */
    var pack = e.target.closest('[data-ol-pack]');
    if (pack) {
      var pdp = pack.closest('[data-ol-pdp]');
      pdp.querySelectorAll('[data-ol-pack]').forEach(function (p) { p.classList.toggle('on', p === pack); });
      pack.querySelector('input[type=radio]') && (pack.querySelector('input[type=radio]').checked = true);
      olRecalc(pdp);
      return;
    }

    /* ---- Frequency selector (one-time / subscribe) ---- */
    var freq = e.target.closest('[data-ol-freq]');
    if (freq) {
      var pdp2 = freq.closest('[data-ol-pdp]');
      pdp2.querySelectorAll('[data-ol-freq]').forEach(function (f) { f.classList.toggle('on', f === freq); });
      pdp2.setAttribute('data-freq', freq.getAttribute('data-ol-freq'));
      olRecalc(pdp2);
      return;
    }

    /* ---- Accordion (why you'll love it / ingredients / how to / faq) ---- */
    var acc = e.target.closest('[data-ol-acc-q]');
    if (acc) {
      var item = acc.closest('[data-ol-acc]');
      var group = acc.closest('[data-ol-accs]');
      var open = item.classList.contains('open');
      if (group && group.hasAttribute('data-single')) {
        group.querySelectorAll('[data-ol-acc].open').forEach(function (i) { i.classList.remove('open'); });
      }
      item.classList.toggle('open', !open);
      return;
    }

    /* ---- Tabs (barber insight episodes etc.) ---- */
    var tab = e.target.closest('[data-ol-tab]');
    if (tab) {
      var wrap = tab.closest('[data-ol-tabs]');
      var key = tab.getAttribute('data-ol-tab');
      wrap.querySelectorAll('[data-ol-tab]').forEach(function (t) { t.classList.toggle('on', t === tab); });
      wrap.querySelectorAll('[data-ol-panel]').forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-ol-panel') === key); });
      return;
    }

    /* ---- Video facade (click to load iframe) ---- */
    var facade = e.target.closest('[data-ol-video]');
    if (facade) {
      var src = facade.getAttribute('data-ol-video');
      if (!src) return;
      var frame = document.createElement('iframe');
      frame.src = src; frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      frame.setAttribute('allowfullscreen', ''); frame.setAttribute('loading', 'lazy');
      frame.setAttribute('title', facade.getAttribute('aria-label') || 'Video');
      facade.replaceWith(frame);
      return;
    }
  });

  /* recalculate the buy box: which variant + selling plan + price */
  window.olRecalc = function (pdp) {
    if (!pdp) return;
    var activePack = pdp.querySelector('[data-ol-pack].on') || pdp.querySelector('[data-ol-pack]');
    if (!activePack) return;
    var freq = pdp.getAttribute('data-freq') || 'onetime';
    var variantId = activePack.getAttribute('data-variant');
    var price = activePack.getAttribute('data-price');
    var compare = activePack.getAttribute('data-compare');
    var subPrice = activePack.getAttribute('data-sub-price') || price;
    var planId = '';
    if (freq === 'subscribe') {
      planId = activePack.getAttribute('data-plan') || '';
      price = subPrice;
    }
    pdp.querySelectorAll('[data-ol-varid]').forEach(function (i) { i.value = variantId; });
    var planInput = pdp.querySelector('[data-ol-planid]');
    if (planInput) { planInput.value = planId; planInput.disabled = !planId; }
    var otBtn = pdp.querySelector('[data-ol-freq="onetime"] [data-ol-buyprice]');
    var subBtn = pdp.querySelector('[data-ol-freq="subscribe"] [data-ol-buyprice]');
    if (otBtn) otBtn.textContent = activePack.getAttribute('data-price') || '';
    if (subBtn) subBtn.textContent = subPrice || '';
    var atcPrice = pdp.querySelector('[data-ol-atc-label] [data-ol-buyprice]');
    if (atcPrice) atcPrice.textContent = price || '';
    var cmp = pdp.querySelector('[data-ol-buycompare]');
    if (cmp) { cmp.hidden = !compare; cmp.textContent = compare || ''; }
  };

  /* ---- AJAX add-to-cart ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest('.ol') || !/\/cart\/add/.test(form.getAttribute('action') || '') || form.closest('product-form')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn && btn.querySelector('[data-ol-atc-label]');
    var original = label && label.textContent;
    if (btn) btn.disabled = true;
    fetch(form.action, { method: 'POST', headers: { 'Accept': 'application/javascript' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { if (btn) btn.disabled = false; return; }
        if (label) { label.textContent = form.getAttribute('data-added') || 'Added ✓'; setTimeout(function () { label.textContent = original; }, 1700); }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-ol-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        }).catch(function () {});
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) setTimeout(function () { btn.disabled = false; }, 200); });
  });

  /* ---- Sticky add-to-cart bar: show once the buy box scrolls out of view ---- */
  document.addEventListener('click', function (e) {
    var stickyBtn = e.target.closest('[data-ol-sticky-btn]');
    if (stickyBtn) {
      var target = document.getElementById('ol-buybox');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  function initSticky() {
    var bar = document.querySelector('[data-ol-sticky]');
    var pdp = document.getElementById('ol-buybox');
    if (!bar || !pdp || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { bar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(pdp);
  }

  /* init each buy box on load */
  function init() {
    document.querySelectorAll('[data-ol-pdp]').forEach(function (p) { olRecalc(p); });
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
